module.exports = __webpack_public_path__ + "img/garden.0ee8cac5.jpg";